
import React from 'react';
import { booleanTestIdFormatter } from "../../../utils/helpers";
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'

const GroupFieldTitleToggle = ({ parentInfo, uniqueKey, field_metadata, onchange, testId, multiple }) => {
  const formattedTestId = booleanTestIdFormatter(testId, field_metadata.isTitle);

  const handleChange = (event) => {
    const eventData = event.target.checked
    field_metadata.isTitle = eventData
    onchange();
  }

  const shouldRender = !multiple && parentInfo.hasParent && parentInfo.isMulti && (parentInfo.data_type === 'group');

  if (!shouldRender) return null

  return (
    <div className="mark-group-title">
      <div className='ToggleWrap'>
        <ToggleSwitch
          testId={formattedTestId}
          name={`${uniqueKey}.isTitle`}
          label="Mark as Group title"
          checked={field_metadata.isTitle || false}
          onChange={handleChange}
          labelPosition="right"
          labelColor="secondary"
        />
      </div>
    </div>
  )
}

export default GroupFieldTitleToggle;
